import { Api } from '@/core/api.js'
const api = new Api()

const state = {
  list: [],
  locations: [],
  facilities: [],
  hotels: []
}

const getters = {
  getList (state) {
    return state.list
  },

  get_location_by_id: (state, getters, rootState) => id => {
    if (typeof state.locations[id] !== 'undefined') return state.locations[id]
    return false
  },

  getLocations: (state, getters, rootState) => () => {
    if (typeof state.locations !== 'undefined') return state.locations
    return false
  },

  getFacilities: (state, getters, rootState) => () => {
    if (typeof state.facilities !== 'undefined') return state.facilities
    return false
  },

  getHotels: (state, getters, rootState) => () => {
    if (typeof state.hotels !== 'undefined') return state.hotels
    return false
  }
}

const actions = {
  // loadTravel: ({commit},params) => {
  //     return api.get('travel/' + params.travel_id).then(function(response){
  //         return commit('setTravel',response.data);
  //     });
  // },

  // updateTravel: ({commit},params) => {
  //     return api.post('travel/' + params.travel_id + '/update', params.input).then(function(response){
  //         return commit('setTravel',response.data);
  //     });
  // },

  loadTeamTravels: ({ commit }, params) => {
    return api.get('travel/' + params.team_id).then(function (response) {
      return commit('setTravel', response.data)
    })
  },

  loadParticipantTravels: ({ commit }, params) => {
    return api.get('travel/3/' + params.id_rel).then(function (response) {
      return commit('setTravel', response.data)
    })
  },

  upload (context, data) {
    var travel = { ...data.data }
    var path =
      typeof travel.id !== 'undefined'
        ? 'travel/' + travel.id + '/update'
        : 'travel/add'
    return api.post(path, travel).then(function (response) {
      if (response.status) {
        var data = response.data
        data.visible = true
        console.log(data.id)

        context.commit('addFacility', data)
        return data.id
      }
    })
  },

  loadTravelInfo ({ dispatch, commit, rootState }, params) {
    return api.get('travel/locations').then(function (response) {
      if (response.status) {
        commit('setLocations', response.data)
        return api
          .post('facility/event/' + rootState.current_event.id, {
            num_page: 0,
            num_items: -1
          })
          .then(function (response) {
            if (response.status) {
              commit('setFacilities', response.data.data)
              return api
                .post('hotel/event/' + rootState.current_event.id, {
                  num_page: 0,
                  num_items: -1
                })
                .then(function (response) {
                  if (response.status) {
                    return commit('setHotels', response.data.data)
                  }
                })
            }
          })
      }
    })
  },

  setTransferOptions ({ commit }, params) {
    return api
      .postJSON('travel/' + params.team_id + '/transfer-options', {
        transfer_options: params.transfer_options
      })
      .then(function (response) {
        return response
      })
  },

  getTransferOptions ({ commit }, params) {
    return api
      .get('travel/' + params.team_id + '/get-transfer-options')
      .then(function (response) {
        return response
      })
  }
}

const mutations = {
  setTravel (state, value) {
    state.list = value
  },

  setLocations (state, data) {
    state.locations = data
  },

  setFacilities (state, data) {
    state.facilities = data
  },

  setHotels (state, data) {
    console.log('HOTELS', data)
    state.hotels = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
